import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { API } from '@/App';

const UserContext = createContext({ user: null, role: 'visiteur', canEdit: false, isAdmin: false, refreshUser: () => {} });

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) {
      setUser(null);
      return;
    }
    try {
      const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
      setUser(res.data);
    } catch {
      setUser(null);
    }
  }, []);

  useEffect(() => { refreshUser(); }, [refreshUser]);

  // Listen for storage/token changes (login/logout)
  useEffect(() => {
    const handleStorage = () => refreshUser();
    window.addEventListener('storage', handleStorage);
    window.addEventListener('user-login', handleStorage);
    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('user-login', handleStorage);
    };
  }, [refreshUser]);

  const role = user?.role || 'visiteur';
  const normalizedRole = role === 'admin' ? 'administrateur' : role === 'consultant' ? 'utilisateur' : role;
  const canEdit = ['directeur', 'administrateur', 'utilisateur'].includes(normalizedRole);
  const isAdmin = ['directeur', 'administrateur'].includes(normalizedRole);
  const isDirector = normalizedRole === 'directeur';
  const CONTACT_DELETE_EMAILS = ['demo@antilles-croissance.com', 'nerro_samy@live.fr'];
  const canDeleteContacts = CONTACT_DELETE_EMAILS.includes(user?.email?.toLowerCase());

  return (
    <UserContext.Provider value={{ user, role: normalizedRole, canEdit, isAdmin, isDirector, canDeleteContacts, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
};
